import { GridColumns as XGridColumns, GridColumnVisibilityModel } from '@mui/x-data-grid-pro';
import { trackException } from 'app-insights/appInsightsTracking';
import _ from 'lodash';

export const defaultFilterName = 'my default';

export enum SearchType {
  candidate = 'candidate',
  tagsCandidateSearch = 'tags-candidate-search',
  placement = 'placement',
  order = 'order',
  facility = 'facility',
  tasks = 'tasks',
  coverage = 'coverage',
  amWorkdesk = 'amWorkdesk',
  orderPlacement = 'orderPlacement',
  unit = 'unit',
  autoTasks='autoTasks',
  orderpaypackage = 'orderpaypackage',
  targetmargins = 'targetmargins'
}

export interface ISearchResults {
  count: number;
  items: unknown[];
  drawerData?: {
    open: boolean;
    data: unknown;
  };
  miscellaneous: IMiscellanoues;
}

export interface IMiscellanoues {
  positionCount?: number;
  jobMatchHealth?: boolean;
  jobInterestHealth?: boolean;
  category?: SearchType;
}

export interface ITargetMargin {
  currentPage: number;
  totalRows: number;
  marginType: string;
  targetMarginId: number;
  targetMarginSourceId?: number;
  targetMarginSource?: string;
  divisionId?: number;
  division?: string;
  facilityId?: number;
  facility?: string;
  orderId?: number;
  disciplineId?: number;
  discipline?: string;
  disciplineAbbr?: string;
  specialtyId?: number;
  specialty?: string;
  specialtyAbbr?: string;
  subSpecialtyId?: number;
  subSpecialty?: string;
  subSpecialtyAbbr?: string;
  state?: string;
  targetMarginDefault?: number;
  targetMarginDayShift?: number;
  targetMarginNightShift?: number;
  targetMarginDayNightShift?: number;
  payRangeMinMaxPercentage?: number;
  defaultWeeklyPay?: number;
  suppress?: boolean;
  positions?: number;
  isActive?: boolean;
  rowKey: number;
}

export interface ITargetMarginSearchParams {
  pageNumber?: number;
  pageSize?: number;
  divisionIds?: string;
  facilityIds?: string;
  orderIds?: string;
  disciplineIds?: string;
  specialtyIds?: string;
  subSpecialtyIds?: string;
  states?: string[];
  targetMarginSourceIds?: string;
  skillsetFilter?: any;
  positionsMin?: number;
  positionsMax?: number;
  defaultTargetMarginMin?: number;
  defaultTargetMarginMax?: number;
  defaultWeeklyPayMin?: number;
  defaultWeeklyPayMax?: number;
  percentageMin?: number;
  percentageMax?: number;
  targetMarginId?: number;
  suppress?: boolean;
  isActive?: boolean;
  marginType?: string;
  sortColumn?: string;
  sortDirection?: string;
}

export enum GlobalSearchGridType {
  standard,
  xGrid,
}

export class GridColumns {
  columns: XGridColumns = [];

  visibilityModel?: GridColumnVisibilityModel;

  constructor(columns: XGridColumns = [], visibilityModel?: GridColumnVisibilityModel) {
    this.columns = columns?.map(item => {
      return {
        field: item.field,
        width: item.width,
        flex: item.flex,
        // filterable: item.filterable,
        // sortable: item.sortable,
        // pinnable: item.pinnable,
        // resizable: item.resizable,
        // editable: item.editable,
      };
    });
    this.visibilityModel = visibilityModel;
  }

  isEqual(gridStateColumns: XGridColumns) {
    const gridStateColumnsClone = _.clone(gridStateColumns);
    if (gridStateColumnsClone?.length > 0 && gridStateColumnsClone[0].field === '__check__') {
      gridStateColumnsClone.shift();
    }
    let equal: boolean = true;
    if (
      gridStateColumnsClone?.length > 0 &&
      this.columns?.length > 0 &&
      gridStateColumnsClone?.length >= this.columns?.length
    ) {
      this.columns?.forEach((item, i) => {
        if (
          item.field !== '__check__' &&
          (item.field !== gridStateColumnsClone[i].field || item.width !== gridStateColumnsClone[i].width)
        ) {
          equal = false;
        }
      });
    } else equal = false;
    return equal;
  }


  isVisibilityModelEqual(gridVisibilityModel: GridColumnVisibilityModel): boolean {
    try {
      const model = _.cloneDeep(gridVisibilityModel);
      return _.isEqual(this.visibilityModel, model);
    } catch (err) {
      trackException({
        exception: err,
        properties: {
          name: 'isVisibilityModelEqual',
          columnsThis: JSON.stringify(this.columns ?? {}),
          visibilityModelThis: JSON.stringify(this.visibilityModel ?? {}),
          incomingVisibilityModel: JSON.stringify(gridVisibilityModel ?? {}),
        },
      });
      return false;
    }
  }
}
